/* eslint-disable @typescript-eslint/no-loss-of-precision */
/* eslint-disable max-len */
/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useRef, useState } from "react";
import commonStyles from "../../styles/commonStyles.module.css";
import styles from "./styles.module.css";
import Image from "next/image";
import { useTranslation } from "next-i18next/pages";
import { toast } from "react-hot-toast";
import queryString from "query-string";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useRouter } from "next/router";
const options = [{
  value: 50,
  label: "≤ 50"
}, {
  value: 100,
  label: "50 - 100"
}, {
  value: 500,
  label: "101 - 500"
}, {
  value: 1000,
  label: "501 - 1000"
}, {
  value: 1001,
  label: "1000+"
}];
const init = {
  "entry.39972936": "",
  "entry.1804134875": "",
  "entry.345399004": "",
  "entry.1807194614": "",
  "entry.573289251": "",
  "entry.325730321": "",
  "entry.934500708": options[0],
  "entry.1522480819": "",
  "entry.179018956": ""
};
const Contact: React.FC = () => {
  const router = useRouter();
  const {
    t
  } = useTranslation('common');
  const [openDropdown, setOpenDropdown] = useState(false);
  const [numerOfLearner, setNumberOfLeaner] = useState(options[0]);
  const [data, setData] = useState<any>(init);
  const [isAccept, setAccept] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const wrapperRef = useRef<any>(null);
  useEffect(() => {
    setOpenDropdown(false);
    handleChange({
      target: {
        name: "entry.934500708",
        value: numerOfLearner.value
      }
    });
  }, [numerOfLearner]);
  useEffect(() => {
    window.addEventListener("click", handleClick);
    return () => {
      window.addEventListener("click", handleClick);
    };
  }, []);
  const checkMail = (email: string) => {
    if (/\S+@\S+\.\S+/.test(email)) {
      setError("");
    } else {
      setError("Email is invalid");
    }
  };
  const handleClick = (event: any) => {
    const {
      target
    } = event;
    if (wrapperRef.current && !wrapperRef.current.contains(target)) {
      setOpenDropdown(false);
    }
  };
  const myRequest = async (url: any) => {
    try {
      await axios.post(url);
    } catch (e) {
      setData(init);
      setNumberOfLeaner(options[0]);
      setAccept(false);
      toast.success(t('Thank you for contacting us!'));
      throw e;
    }
  };
  const handleChange = (e: any) => {
    const newData = {
      ...data,
      ...{
        [e.target.name]: e.target.value
      }
    };
    setData(newData);
  };
  const handleSubmit = (e: any) => {
    if (isDisbled() === 1) {
      const id = "1FAIpQLSeD4PYkZNmU-0q-AMPI6GQmUkmGmNX-xbi3TrNkF1BH-7IImQ";
      e.preventDefault();
      const formUrl = "https://docs.google.com/forms/d/e/" + id + "/formResponse";
      const q = queryString.stringifyUrl({
        url: formUrl,
        query: data
      });
      myRequest(q);
    }
  };
  const isDisbled = () => {
    if (!error && isAccept && Object.values(data).length === 9 && Object.values(data).every(v => !!v)) return 1;
    return 0.5;
  };
  return <div className={styles.contactContainer}>
      <img className={styles.background} src="/v3/contact/background.png" alt="bg" />
      <div className={commonStyles.container}>
        <img className={styles.ellipse} alt="ellipse" src="/v3/hero-section/ellipse.png" />
        <div style={{
        position: "relative",
        zIndex: 2
      }}>
          <div style={{
          position: "relative"
        }}>
            <div className={styles.formContainer}>
              <div className={styles.header}>
                <section>
                  <div>
                    {t('Contact Us')}
                  </div>
                  <div>
                    {t('24/7 Support')}
                  </div>
                </section>
                <div className={styles.bTitle}>
                  <div>
                    {t('Get Your ZenClass Journey Started')}
                  </div>
                  <div>
                    {t('Get in touch with us through the right channels')}
                  </div>
                </div>
              </div>
              <div className={styles.form}>
                <div className={commonStyles.rowForm}>
                  <div className={commonStyles.field}>
                    <label>
                      {t('First name')}
                    </label>
                    <input value={data["entry.39972936"]} onChange={handleChange} name="entry.39972936" placeholder={t('Enter first name')} />
                  </div>
                  <div className={commonStyles.field}>
                    <label>
                      {t('Last name')}
                    </label>
                    <input value={data["entry.1804134875"]} onChange={handleChange} name="entry.1804134875" placeholder={t('Enter last name')} />
                  </div>
                </div>
                <div className={commonStyles.rowForm}>
                  <div className={commonStyles.field}>
                    <label>
                      {t('Email')}
                    </label>
                    <div style={{
                    display: "flex",
                    gap: 5,
                    flexDirection: "column",
                    width: "100%"
                  }}>
                      <input onBlur={e => checkMail(e.target.value)} type="email" value={data["entry.345399004"]} onChange={handleChange} name="entry.345399004" placeholder={t('Enter your email')} />
                      {error && <span style={{
                      fontSize: 12,
                      fontStyle: "italic",
                      color: "red"
                    }}>
                          {error}
                        </span>}
                    </div>
                  </div>
                </div>

                <div className={commonStyles.rowForm}>
                  <div className={commonStyles.fieldPhone}>
                    <label>
                      {t('Contact phone number')}
                    </label>
                    <div style={{
                    display: "flex",
                    gap: 5,
                    flexDirection: "column",
                    width: "100%"
                  }}>
                      <PhoneInput country={router.locale !== "vn" ? "us" : router.locale} enableSearch={true} value={data["entry.1807194614"]} onChange={phone => handleChange({
                      target: {
                        name: "entry.1807194614",
                        value: phone
                      }
                    })} />
                    </div>
                  </div>
                </div>
                <div className={commonStyles.rowForm}>
                  <div className={commonStyles.field}>
                    <label>
                      {t('Job title')}
                    </label>
                    <input value={data["entry.573289251"]} onChange={handleChange} name="entry.573289251" placeholder={t('Ex: Academic Manager')} />
                  </div>
                </div>
                <div className={commonStyles.rowForm}>
                  <div className={commonStyles.field}>
                    <label>
                      {t('Organisation name')}
                    </label>
                    <input value={data["entry.325730321"]} onChange={handleChange} name="entry.325730321" placeholder={t('Enter your organisation name')} />
                  </div>
                  <div className={commonStyles.field}>
                    <label>
                      {t('Number of learner')}
                    </label>
                    <div style={{
                    position: "relative",
                    width: "100%"
                  }} ref={wrapperRef}>
                      <div onClick={() => setOpenDropdown(!openDropdown)} className={commonStyles.select}>
                        {numerOfLearner.label}
                        <div style={{
                        transform: `rotate(${openDropdown ? -180 : 0}deg)`,
                        display: "flex",
                        alignItems: "center"
                      }}>
                          <Image src="/v3/contact/keyboard_arrow_down.png" alt="arrow" width={16} height={16} />
                        </div>
                      </div>
                      {openDropdown && <div className={styles.dropdownMenu}>
                          {options.map((o, index) => <div onClick={() => setNumberOfLeaner(o)} key={index}>
                              {o.label}
                            </div>)}
                        </div>}
                    </div>
                  </div>
                </div>
                <div className={commonStyles.rowForm}>
                  <div className={commonStyles.field}>
                    <label>
                      {t('When do you want to start using ZenClass services?')}
                    </label>
                    <input value={data["entry.1522480819"]} onChange={handleChange} name="entry.1522480819" placeholder={t('Enter your answer')} />
                  </div>
                </div>
                <div className={commonStyles.rowForm}>
                  <div className={commonStyles.field}>
                    <label>
                      {t('How can we help you?')}
                    </label>
                    <textarea value={data["entry.179018956"]} onChange={handleChange} name="entry.179018956" placeholder={t('Leave your request')} />
                  </div>
                </div>
                <div className={styles.checkboxContainer}>
                  <input type="checkbox" checked={isAccept} onChange={() => setAccept(!isAccept)} />
                  <div className={styles.confirm}>
                    {t('I have read and agreed to ZenClass')}{" "}
                    <a target="_blank" href="/privacy-and-policy">
                      {t('Privacy Policy')}
                    </a>{" "}
                    {t('and')}{" "}
                    <a target="_blank" href="/terms-and-conditions">
                      {t('Terms and Conditions')}
                    </a>
                    .
                  </div>
                </div>
                <button className={`${commonStyles.buttonPrimary} ${commonStyles.submitBtn}`} style={{
                opacity: isDisbled()
              }} onClick={handleSubmit}>
                  {t('Submit')}
                  <Image alt="send" src="/v3/send.svg" width={20} height={20} />
                </button>
              </div>
            </div>
            <img className={styles.backgroundMobile} src="/v3/contact/background.png" alt="bg" />
          </div>
          <div>
            <div className={styles.title}>
              {t('Get in touch with us through the right channels')}
            </div>
            <div className={styles.listCard}>
              <div className={styles.card}>
                <img alt="contact" src="/v3/contact/1.png" />
                <div className={styles.content}>
                  <div>
                    {t('24x7 Support')}
                  </div>
                  <div>
                    {t('Check out our support docs to find answers to common questions.')}
                  </div>
                </div>
                <div style={{
                display: "flex",
                gap: 16,
                alignItems: "center"
              }}>
                  <Image alt="mail" src="/v3/contact/mail_outline.svg" width={24} height={24} />
                  <div className={styles.mail}>support@zenclass.co</div>
                </div>
              </div>
              <div className={styles.card}>
                <img alt="contact" src="/v3/contact/2.png" />
                <div className={styles.content}>
                  <div>
                    {t('Careers')}
                  </div>
                  <div>
                    {t("Want to join our team? We'd love to hear from you!")}
                  </div>
                </div>
                <div style={{
                display: "flex",
                gap: 16,
                alignItems: "center"
              }}>
                  <Image alt="mail" src="/v3/contact/mail_outline.svg" width={24} height={24} />
                  <div className={styles.mail}>careers@zenclass.co</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Contact;